(function () {
  console.log('🚀 Shopify Collection Search + Facets Initialized');

  const searchInput = document.getElementById('CollectionSearchInput');
  const searchButton = document.querySelector('.cstm-search-model .search__button');

  if (!searchInput) {
    console.warn('❌ CollectionSearchInput not found');
    return;
  }

  let debounceTimer = null;

  /* ---------------------------------------------
    FACET LABEL FILTERING (UI ONLY)
  --------------------------------------------- */
  function filterFacetLabels(term) {
    document.querySelectorAll('.list-menu__item.facets__item').forEach(item => {
      const label = item.querySelector('.facet-checkbox__text-label');
      if (!label) return;

      const text = label.textContent.toLowerCase().trim();
      item.style.display = text.includes(term) ? '' : 'none';
    });
  }

  function resetFacetLabels() {
    document.querySelectorAll('.list-menu__item.facets__item').forEach(item => {
      item.style.display = '';
    });
  }

  /* ---------------------------------------------
    FIND MATCHING SPECIES FACET (IMPORTANT FIX)
  --------------------------------------------- */
  function getMatchingFacetFilter(term) {
    const inputs = document.querySelectorAll(
      '.facets__list input[type="checkbox"]'
    );

    for (const input of inputs) {
      const labelEl = input
        .closest('.facets__item')
        ?.querySelector('.facet-checkbox__text-label');

      if (!labelEl) continue;

      const label = labelEl.textContent.toLowerCase().trim();

      // exact or starts-with match
      if (label === term || label.startsWith(term)) {
        return {
          param: input.name,
          value: input.value
        };
      }
    }
    return null;
  }

  /* ---------------------------------------------
    APPLY COLLECTION FILTER (SERVER DRIVEN)
  --------------------------------------------- */
  function applyCollectionSearch(term) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Remove existing facet filters
    [...params.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        params.delete(key);
      }
    });

    // Remove q search (not used here)
    params.delete('q');
    params.delete('options[prefix]');

    if (!term) {
      console.log('🔄 Clearing filters');
      FacetFiltersForm.renderPage(params.toString());
      return;
    }

    const facetMatch = getMatchingFacetFilter(term);

    if (facetMatch) {
      console.log('✅ Applying facet filter:', facetMatch);
      params.append(facetMatch.param, facetMatch.value);
    } else {
      console.log('⚠️ No facet match found for:', term);
    }

    FacetFiltersForm.renderPage(params.toString());
  }

  /* ---------------------------------------------
    RESTORE SEARCH FROM URL
  --------------------------------------------- */
  function restoreSearchFromURL() {
    const url = new URL(window.location.href);
    let restored = '';

    for (const [key, value] of url.searchParams.entries()) {
      if (key.startsWith('filter.')) {
        restored = value;
        break;
      }
    }

    if (restored) {
      searchInput.value = restored;
      filterFacetLabels(restored.toLowerCase());
    }
  }

  /* ---------------------------------------------
    CLEAR SEARCH WHEN "CLEAR ALL" / "RESET"
  --------------------------------------------- */
  document.addEventListener('click', e => {
    const el = e.target;

    const isClear =
      el.closest('.active-facets__button-remove') ||
      el.closest('.facets__reset') ||
      el.textContent?.toLowerCase().includes('clear all') ||
      el.textContent?.toLowerCase().includes('reset');

    if (!isClear) return;

    console.log('🧹 Clearing search');

    searchInput.value = '';
    resetFacetLabels();

    const url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    });

    history.replaceState({}, '', url.toString());
  });

  /* ---------------------------------------------
    INPUT HANDLERS
  --------------------------------------------- */
  function handleSearch() {
    const term = searchInput.value.trim().toLowerCase();
    filterFacetLabels(term);
    applyCollectionSearch(term);
  }

  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(handleSearch, 400);
  });

  searchInput.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(debounceTimer);
      handleSearch();
    }
  });

  if (searchButton) {
    searchButton.addEventListener('click', () => {
      clearTimeout(debounceTimer);
      handleSearch();
    });
  }

  /* ---------------------------------------------
    OBSERVE FACET RE-RENDERS (SORT / FILTER)
  --------------------------------------------- */
  const facetObserver = new MutationObserver(() => {
    const term = searchInput.value.trim().toLowerCase();
    if (term) filterFacetLabels(term);
  });

  const facetsWrapper = document.getElementById('FacetsWrapperDesktop');
  if (facetsWrapper) {
    facetObserver.observe(facetsWrapper, {
      childList: true,
      subtree: true
    });
  }

  restoreSearchFromURL();
})();


(function () {
  setInterval(() => {
    const drawer = document.querySelector("spark-drawer");
    if (!drawer) return;
    if (!drawer.shadowRoot) return;
    const shadow = drawer.shadowRoot;
    const buttons = shadow.querySelectorAll("button");
    buttons.forEach(button => {
      const text = button.textContent || "";
      if (text.includes("Upload a file") || text.includes("Scan a barcode") || text.includes("Forward an email")) {
        // console.log("Removing:", text.trim());
        button.remove();
      }
    });

    shadow.querySelectorAll("p.flex.items-center").forEach(p => {
      const text = p.textContent || "";

      if (text.includes("plant_height") || text.includes("plant_length") || text.includes("plant_base_width") || text.includes("tray_quantity")) {
        // console.log("Hiding property:", text.trim());
        p.style.display = "none";
      }
    });

    // Hide qty + delete for CCTrolley1 (Trolley Delivery)
    // shadow.querySelectorAll("p.hidden.text-default-body, p.block.text-default-body").forEach(p => {
    //   const text = (p.textContent || "").trim();
    //   if (text === "SKU: CCTrolley1" || text === "SKU: courier-shipping") {
    //     const lineItem = p.closest(".flex.w-full.gap-x-4");
    //     if (!lineItem) return;

    //     // Hide quantity selector (the w-28/w-32 wrapper)
    //     const qtyWrapper = lineItem.querySelector(".flex.h-10.w-28, .flex.h-10.w-32");
    //     if (qtyWrapper) qtyWrapper.style.display = "none";

    //     // Hide delete button (the one containing svg-delete)
    //     const deleteBtn = lineItem.querySelector("svg-delete")?.closest("button");
    //     if (deleteBtn) deleteBtn.style.display = "none";
    //   }
    // });
    shadow.querySelectorAll("p.hidden.text-default-body, p.block.text-default-body").forEach(p => {
      const text = (p.textContent || "").trim();
      if (text === "SKU: CCTrolley1" || text === "SKU: courier-shipping") {
        const lineItem = p.closest(".flex.w-full.gap-x-4");
        if (!lineItem) return;

        lineItem.style.pointerEvents = "none";
      }
    });

  }, 300);
})();


// (function () {

//   console.log("Spark delegated inventory guard started");

//   document.addEventListener("click", function (event) {

//     const path = event.composedPath();

//     const plusBtn = path.find(el =>
//       el?.tagName === "SVG-PLUS"
//     )?.closest("button");

//     const minusBtn = path.find(el =>
//       el?.tagName === "SVG-MINUS"
//     )?.closest("button");

//     if (!plusBtn && !minusBtn) return;

//     const sparkCard = path.find(el =>
//       el?.tagName === "SPARK-PRODUCT-CARD"
//     );

//     if (!sparkCard || !sparkCard.shadowRoot) return;

//     const inventory = parseInt(
//       sparkCard.getAttribute("data-inventory"),
//       10
//     );

//     if (!inventory) return;

//     const shadow = sparkCard.shadowRoot;
//     const input = shadow.querySelector("input[type='number']");
//     const plus = shadow.querySelector("svg-plus")?.closest("button");
//     const minus = shadow.querySelector("svg-minus")?.closest("button");

//     if (!input) return;

//     // Wait for Spark to update value
//     setTimeout(() => {

//       const currentQty = parseInt(input.value || 0, 10);

//       if (currentQty >= inventory) {

//         input.value = inventory;

//         showMessage(shadow, input, inventory);

//         plus.disabled = true;
//         minus.disabled = true;
//         input.disabled = true;
//       }

//     }, 50);

//   });


//   function showMessage(shadow, input, inventory) {

//     let msg = shadow.querySelector(".max-qty-message");

//     if (!msg) {
//       msg = document.createElement("div");
//       msg.className = "max-qty-message";
//       msg.style.cssText = `
//         font-size:12px;
//         color:#d32f2f;
//         margin-top:6px;
//       `;

//       input.closest(".quantity-selector-wrapper")
//            .appendChild(msg);
//     }

//     msg.textContent = "Max quantity available: " + inventory;
//     msg.style.display = "block";

//     setTimeout(() => {
//       msg.style.display = "none";
//     }, 1000);
//   }

// })();